// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"763":"87b9886c","908":"e6c305df"}[chunkId] + ".js";
};